import { parseKeywordIntegratedSearchPostVo } from '@/parsers/search';

import { useGetKeywordSearchPostQuery } from './search.gql.impl';

const KEYWORD_SEARCH_SIZE = 4;

const useGetKeywordIntegratedSearchPost = (keyword: string) => {
  const { data: keywordSearchPost, isLoading: isKeywordSearchPostLoading } =
    useGetKeywordSearchPostQuery(
      {
        request: {
          keyword,
          size: KEYWORD_SEARCH_SIZE,
        },
      },
      {
        select: parseKeywordIntegratedSearchPostVo,
        enabled: keyword.length > 0,
      },
    );

  return {
    keywordSearchPost,
    isKeywordSearchPostLoading,
  };
};

export default useGetKeywordIntegratedSearchPost;
